import clsx from "clsx";
import { StaticImageData } from "next/image";

import { Image } from "@/components/displays";

import styles from "./ThumbnailImages.module.scss";

interface ThumbnailImagesProps {
  imageSrcs: (string | StaticImageData)[];
  onClick: (index: number) => void;
  startIndex?: number;
  endIndex?: number;
}

export function ThumbnailImages({
  imageSrcs,
  onClick,
  startIndex,
  endIndex,
}: ThumbnailImagesProps): React.ReactNode {
  return (
    <ul className={clsx(styles.container)}>
      {imageSrcs.map((image, index) => {
        const isHidden =
          startIndex != null && endIndex != null && (index < startIndex || index >= endIndex);
        const key = typeof image === "string" ? image : image.src;
        return (
          <li
            key={key}
            className={clsx(styles.item)}
            onClick={() => onClick(index)}
            style={isHidden ? { display: "none" } : {}}
          >
            <button className={clsx(styles.button)} data-thumbnail-id="16770799239229" data-zoom="">
              <Image src={image} alt={`商品画像-${index}`} width={87} height={87} sizes="87px" />
            </button>
          </li>
        );
      })}
    </ul>
  );
}
